import {MapNode, NodeType} from 'common/src/modules/nodes/nodes.types';
import {
  ContentFeedNode,
  DTCampaignNode,
  DTConditionNode,
  DTCreativeNode,
  DTDistributionNode,
  DTNativeCreativeNode,
  DTOptimizationNode,
  DTProductSelectionNode,
  DTScheduleNode,
  DTSequenceNode,
  DTStoreNode,
  DTWeightedNode,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {campaignCardToText} from './campaignCardToText';
import {conditionCardToText} from './conditionCardToText';
import {contentCardToText} from './contentCardToText';
import {creativeCardToText} from './creativeCardToText';
import {distributionCardToText} from './distributionCardToText';
import {locationCardToText} from './locationCardToText';
import {nativeCreativeCardToText} from './nativeCreativeCardToText';
import {optimizationCardToText} from './optimizationCardToText';
import {productCardToText} from './productCardToText';
import {scheduleCardToText} from './scheduleCardToText';
import {sequenceCardToText} from './sequenceCardToText';
import {weightedCardToText} from './weightedCardToText';

export type TextMode = 'short' | 'full';

export function cardToText(card: MapNode, mode: TextMode): string | null {
  switch (card.type) {
    case NodeType.CAMPAIGN:
      return campaignCardToText(card as DTCampaignNode, mode);
    case NodeType.CONDITION:
      return conditionCardToText(card as DTConditionNode, mode);
    case NodeType.CONTENT_FEED:
      return contentCardToText(card as ContentFeedNode, mode);
    case NodeType.CREATIVE:
    case NodeType.CONCEPT_CREATIVE:
      return creativeCardToText(card as DTCreativeNode, mode);
    case NodeType.DISTRIBUTION:
      return distributionCardToText(card as DTDistributionNode, mode);
    case NodeType.STORE:
      return locationCardToText(card as DTStoreNode, mode);
    case NodeType.GENERAL_OPTIMIZATION:
      return optimizationCardToText(card as DTOptimizationNode, mode);
    case NodeType.PRODUCTS:
      return productCardToText(card as DTProductSelectionNode, mode);
    case NodeType.SCHEDULE:
      return scheduleCardToText(card as DTScheduleNode, mode);
    case NodeType.SEQUENCE:
      return sequenceCardToText(card as DTSequenceNode, mode);
    case NodeType.WEIGHTED:
      return weightedCardToText(card as DTWeightedNode, mode);
    case NodeType.NATIVE_CREATIVE:
      return nativeCreativeCardToText(card as DTNativeCreativeNode, mode);
    default:
      return null;
  }
}

export {campaignCardToText} from './campaignCardToText';
export {conditionCardToText} from './conditionCardToText';
export {contentCardToText} from './contentCardToText';
export {creativeCardToText} from './creativeCardToText';
export {distributionCardToText} from './distributionCardToText';
export {locationCardToText} from './locationCardToText';
export {nativeCreativeCardToText} from './nativeCreativeCardToText';
export {optimizationCardToText} from './optimizationCardToText';
export {productCardToText} from './productCardToText';
export {scheduleCardToText} from './scheduleCardToText';
export {sequenceCardToText} from './sequenceCardToText';
export {weightedCardToText} from './weightedCardToText';
export {
  getBaseHeader,
  getDestinationPhrase,
  getOutputIdentifier,
  getOutputTypePhrase,
} from './utils';
